import { Route, Routes } from "react-router-dom"
import MainContainer from "./containers/MainContainer";
import Client from "./components/client";
import Login from "./pages/Login";
import Dashboard from "./components/dashboard";
import Project from "./components/project";
import Detail from "./components/project/Detail";
import FullMode from "./components/dashboard/FullMode";
import Setups from "./components/schedule/setup";
import Codings from "./components/schedule/coding";
import CarsClass from "./components/cars_class";
import AllFullMode from "./components/dashboard/AllFullMode";
// import Dashboard_Old from "./components/dashboard/index_old";

const MainRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<MainContainer target={<FullMode />} menuKey={'DASHBOARD'}/>} />
            {/* <Route path="/dashboard2" element={<MainContainer target={<Dashboard_Old />} menuKey={'DASHBOARD'}/>} /> */}
            <Route path="/client" element={<MainContainer target={<Client />} menuKey={'CLIENT'}/>} />
            <Route path="/project" element={<MainContainer target={<Project />} menuKey={'PROJECT'}/>} />
            <Route path="/project/:pno" element={<MainContainer target={<Detail />} menuKey={'PROJECT_DETAIL'}/>} />
            <Route path="/schedule/setup" element={<MainContainer target={<Setups />} menuKey={'SCHEDULE_SETUP'}/>} />
            <Route path="/schedule/coding" element={<MainContainer target={<Codings />} menuKey={'SCHEDULE_CODING'}/>} />

            <Route path="/cars" element={<MainContainer target={<CarsClass/>} menuKey={'CARS'}/>} />

            <Route path="/dashboard" element={<FullMode />} />


            <Route path="/allDashboard" element={<AllFullMode />} />
            {/* <Route path="/" element={<MainContainer target={<FullMode />} menuKey={'DASHBOARD'}/>} /> */}
        </Routes>
    )
}

export default MainRoutes;